import type {SelectedContextualMenuItems} from '@Components/ai-prompt-box/ai-prompt-box.types';
import {getSessionStorageItem, setSessionStorageItem, removeSessionStorageItem} from '@Utils/session-storage.util';
import {getUniqueString} from '@Utils/string.util';

export interface GenerationBatch<T> {
  id: string;
  prompt: string;
  items: T[];
}

export const createGenerationBatch = <T>(prompt: string, items: T[]): GenerationBatch<T> => {
  return {id: getUniqueString(), prompt, items};
};

export interface StoredGenerationData<T> {
  lastPrompt: string;
  batches: GenerationBatch<T>[];
}

export const getStoredData = <T>(sessionStorageKey: string): StoredGenerationData<T> | null => {
  const parsedData = getSessionStorageItem(sessionStorageKey) as StoredGenerationData<T> | null;

  if (parsedData?.lastPrompt && Array.isArray(parsedData.batches) && parsedData.batches.length > 0) {
    return parsedData;
  }

  clearGenerationSessionData(sessionStorageKey);
  return null;
};

export const saveToSession = <T>(sessionStorageKey: string, data: StoredGenerationData<T>): void => {
  setSessionStorageItem(sessionStorageKey, data);
};

export const clearGenerationSessionData = (sessionStorageKey: string): void => {
  removeSessionStorageItem(sessionStorageKey);
};

export const flattenContextualMenuOptions = (options: SelectedContextualMenuItems): Record<string, string> => {
  const flattened: Record<string, string> = {};

  for (const [key, value] of Object.entries(options)) {
    flattened[key] = value[0] ?? '';
  }

  return flattened;
};
